import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"

export enum DateType {
    ORDER_DATE = "ORDER_DATE",
    DELIVERY_DATE = "DELIVERY_DATE",
    BOOKED_DATE = "BOOKED_DATE",
}

// BOOKED_DATE only makes sense for bookable order types, so it is opt-in per screen
export const DEFAULT_DATE_TYPE_OPTIONS: readonly DateType[] = [DateType.ORDER_DATE, DateType.DELIVERY_DATE]

type SelectDateTypeFilterProps = {
    dateType: DateType
    setDateType: (val: DateType) => void
    options?: readonly DateType[]
    className?: string
    inputLabelClasses?: string
}

export function SelectDateTypeFilter({
    dateType,
    setDateType,
    options = DEFAULT_DATE_TYPE_OPTIONS,
    className,
    inputLabelClasses,
}: SelectDateTypeFilterProps) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="table-select-data-type-filter-on-label">
                <InputLabel id="supplier-pos-table-select-filter">Filter on</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="table-select-data-type-filter-on-label-label" attrs={{ label: true }}>
                <Select
                    labelId="supplier-pos-table-select-filter"
                    id="supplier-pos-table-select-filter-on"
                    value={dateType}
                    label="Filter on"
                    onChange={(e) => setDateType(e.target.value as DateType)}
                    className={className}
                >
                    {options.map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum base="table-select-data-type-filter-on-item" enumValue={value}>
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
